import { createSelector } from 'reselect'

import { componentSelector } from 'wordpress/selectors'
import { createDenormalizedSelector } from 'entities/selectors'
import { promotionSchema } from 'wordpress/schemas'

export const promotionsRibbonSelector = componentSelector('promotionsRibbon')

export const promotedOfferIdSelector = createSelector(
    promotionsRibbonSelector,
    promotionsRibbon => promotionsRibbon.promotedOffer
)

export const promotedOfferSelector = createDenormalizedSelector(promotedOfferIdSelector, promotionSchema)
